<!-- Content Header (Page header) -->
<section class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-2">
        <h1>Organisations</h1>

      </div>

      <div class="col-sm-4">
        <button [disabled]="isLoading$ | async" mat-mini-fab color="primary" >
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
      <div class="col-sm-6">
       
        <ol class="breadcrumb float-sm-right">
          <li class="breadcrumb-item"><a href="#">Home</a></li>
          <li class="breadcrumb-item active">Organisations</li>
        </ol>
      </div>
    </div>
  </div>
  <!-- /.container-fluid -->
</section>

<section class="content">
  <div class="container-fluid">

    <div class="col-lg-12">
      <mat-form-field appearance="standard">
        <mat-label>Filter</mat-label>
        <input
          matInput
          (keyup)="applyFilter($event)"
          placeholder="Ex. 'Saint-Basile-Le-Grand' or 'SBLG' or '8'"
          #input
        />
      </mat-form-field>
      <mat-progress-bar
        mode="indeterminate"
        *ngIf="isLoading$ | async"
      ></mat-progress-bar>
      <mat-table [dataSource]="dataSource$ | async" class="mat-elevation-z8">
        <!-- Name Column -->
        <ng-container matColumnDef="name" sticky>
          <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <b>{{ element.name }}</b>, {{element.stateShortCode}}
          </mat-cell>
        </ng-container>

        <!-- Tag Column -->
        <ng-container matColumnDef="tag">
          <mat-header-cell *matHeaderCellDef> Tag </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.tag }}
          </mat-cell>
        </ng-container>

        <!-- TimeZone Column -->
        <ng-container matColumnDef="timezone">
          <mat-header-cell *matHeaderCellDef> TimeZone </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.timeZone }}
          </mat-cell>
        </ng-container>

        <!-- bcitiId Column -->
        <ng-container matColumnDef="bcitiId">
          <mat-header-cell *matHeaderCellDef> bcitiId </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div *ngIf="element.bcitiId; else noBcitiId">
              {{ element.bcitiId }}
            </div>
            <ng-template #noBcitiId> - </ng-template>
          </mat-cell>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions" stickyEnd>
          <mat-header-cell *matHeaderCellDef aria-label="row actions"
            >&nbsp;</mat-header-cell
          >

          <mat-menu #appMenu="matMenu">
            <ng-template matMenuContent let-tag="tag">
              <!-- TODO: Add useful actions -->
              <button
                mat-menu-item
                routerLink="/organisation/{{ tag }}/cards"
                class="nav-icon"
              >
                <mat-icon>contacts</mat-icon> Cards
              </button>
              <button
                mat-menu-item
                routerLink="/organisation/{{ tag }}/connectors"
                class="nav-icon"
              >
                <mat-icon>power</mat-icon> Connectors
              </button>
              <button
                mat-menu-item
                routerLink="/organisation/{{ tag }}/rss-feeds"
                class="nav-icon"
              >
                <mat-icon>rss_feed</mat-icon> RSS Feeds
              </button>
              <button
                mat-menu-item
                routerLink="/organisation/{{ tag }}/calendar"
                class="nav-icon"
              >
                <mat-icon>calendar_today</mat-icon> Calendar
              </button>
              <button
                mat-menu-item
                routerLink="/organisation/{{ tag }}/user-import"
                class="nav-icon"
              >
                <mat-icon>import_contacts</mat-icon> User import
              </button>
              <button
                mat-menu-item
                routerLink="/organisation/{{ tag }}/features"
                class="nav-icon"
              >
                <mat-icon>settings</mat-icon> Features
              </button>
              <button
                mat-menu-item
                routerLink="/organisation/{{ tag }}/discrepancies"
                class="nav-icon"
              >
                <mat-icon>ballot</mat-icon> Data discrepancies
              </button>
            </ng-template>
          </mat-menu>
          <mat-cell *matCellDef="let element">
            <button
              mat-icon-button
              [matMenuTriggerFor]="appMenu"
              [matMenuTriggerData]="{ tag: element.tag }"
              (click)="$event.stopPropagation()"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row 
          *matRowDef="let row; columns: displayedColumns" 
          (click)="handleClick($event, row)"
        ></mat-row>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell center" colspan="4">
            No data matching the filter "{{ input.value }}"
          </td>
        </tr>
      </mat-table>
    </div>
  </div>
</section>
